import { Typography } from "@material-ui/core"
import styled from "styled-components"
import ClassicPopUp from "./ClassicPopUp"

const StyledText = styled(Typography).attrs({ variant: "body1" })`
  /* margin-top: 20px; */
  text-align: center;
`

type ErrorLocationPopUpProps = {
  open: boolean
  setOpen: (value: boolean) => void
  setUserHasSeenPopUpError: (value: boolean) => void
}

const ErrorLocationPopUp = ({
  open,
  setOpen,
  setUserHasSeenPopUpError,
}: ErrorLocationPopUpProps) => {
  return (
    <ClassicPopUp
      open={open}
      setOpen={setOpen}
      title="המיקום הנוכחי לא זמין"
      onClose={() => setUserHasSeenPopUpError(true)}
    >
      <StyledText>
        המיקום הנוכחי לא זמין. יש לאשר גישה לגבי המיקום שלך
      </StyledText>
    </ClassicPopUp>
  )
}

export default ErrorLocationPopUp
